import { createContext, useContext } from 'react';
import { QBarChartSegment } from './BarChart';

export const createPercentageValue = (total: number, value: number): number =>
  total === 0 ? 0 : (value / total) * 100;

const formatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
});

export const formatNumber = (value: number): string => formatter.format(value);

export type ChartContextType = {
  data: readonly QBarChartSegment[];
  getPercentage: (value: number) => number;
  formatNumber: (value: number) => string;
};

const context = createContext<ChartContextType | null>(null);

export const BarChartContextProvider = context.Provider;

export const useQBarChartConext = (): ChartContextType => {
  const ctx = useContext(context);
  if (!ctx) {
    throw new Error('BarSegment must be used within ChartContext');
  }
  return ctx;
};
